
const validateChecklistTimerConfig = (timerConfig) => {
    let hasErrors = false;
    let updatedTimer = { ...timerConfig, errors: {}, default: false };

    if (updatedTimer.duration == null || updatedTimer.duration == "") {
        updatedTimer.errors.duration = "Duration must be set";
        hasErrors = true;
    } else {
        const duration = parseInt(updatedTimer.duration);
        if (isNaN(duration)) {
            updatedTimer.errors.duration = "Duration must be a number";
            hasErrors = true;
        } else if (duration < 10) {
            updatedTimer.errors.duration = "Duration must be 10 or greater";
            hasErrors = true;
        }
    }

    if (updatedTimer.max != null && updatedTimer.max != "") {
        const max = parseInt(updatedTimer.max);
        if (isNaN(max)) {
            updatedTimer.errors.max = "Max must be a number";
            hasErrors = true;
        }
    }

    if (updatedTimer.correctiveActionType == null) {
        updatedTimer.errors.correctiveActionType = "Corrective action type must be set";
        hasErrors = true;
    }

    if (updatedTimer.checklistTaskTimerNotificationConfigs?.length > 0) {
        updatedTimer.checklistTaskTimerNotificationConfigs.forEach((notification) => {
            notification.errors = {};
            if (notification.value == null || notification.value == "") {
                notification.errors.value = "Notification value must be set";
                hasErrors = true;
            } else {
                const value = parseInt(notification.value);
                if (isNaN(value)) {
                    notification.errors.value = "Notification value must be a number";
                    hasErrors = true;
                } else if (value < 10) {
                    notification.errors.value = "Notification value must be 10 or greater";
                    hasErrors = true;
                }
            }

            if (notification.notificationType == null) {
                notification.errors.notificationType = "Notification type must be set";
                hasErrors = true;
            }
        });
    } else {
        updatedTimer.errors.checklistTaskTimerNotificationConfigs = "At least one notification configuration required";
        hasErrors = true;
    }

    return ({
        hasErrors: hasErrors,
        updatedTimer: updatedTimer
    });
};

export { validateChecklistTimerConfig };